import api from '../../helpers/axios'

export const state = {
    contractProduct: null,
    contractProducts: []
};

export const getters = {
    contractProduct: (state) => state.contractProduct,
    contractProducts: (state) => state.contractProducts
};

export const mutations = {
    setContractProduct(state, newValue) {
        state.contractProduct = newValue;
    },
    setContractProducts(state, newValue) {
        state.contractProducts = newValue;
    },
};

export const actions = {
    createContractProduct(_, {contractId, data}) {
        return new Promise((resolve) => {
            api.post(`/contracts/${contractId}/products`, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    updateContractProduct(_, {contractId, id, data}) {
        return new Promise((resolve) => {
            api.put(`/contracts/${contractId}/products/`+id, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deleteContractProduct(_, {contractId,id}) {
        return new Promise((resolve) => {
            api.delete(`/contracts/${contractId}/products/`+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchContractProduct({ commit }, {contractId,id}) {
        return new Promise((resolve,reject) => {
            api.get(`/contracts/${contractId}/products/`+id).then((res) => {
                commit("setContractProduct", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchContractProducts({ commit }, {contractId, page, limit}) {
        let query = "?";
        query += `page=${page}&`;
        query += `limit=${limit}&`;
        return new Promise((resolve) => {
            api.get(`/contracts/${contractId}/products`+query).then((res) => {
                commit("setContractProducts", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
